import { createSelector } from 'reselect';
import precise from '../modules/precise';

const SVCFeesTotalSelector = state => state.registration.SVCFEE_TOTAL;
const BaseFeeSelector = state => state.registration.BaseFee;

// Rsub1a
const totalBaseAndSVCFee = createSelector(
  [SVCFeesTotalSelector, BaseFeeSelector],
  (a, b) => precise(Number(a) + Number(b)),
);

export default totalBaseAndSVCFee;



// WEBPACK FOOTER //
// ./src/selectors/totalBaseAndSVCFee.selector.js